import React, { useState } from 'react';

import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import FormControlLabel from '@mui/material/FormControlLabel';

import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import SvgIcon from "@mui/material/SvgIcon";
import Icon from "@mui/material/Icon";
import Stack from '@mui/material/Stack';

import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

import Slider from '@mui/material/Slider';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Divider from '@mui/material/Divider';

import SettingsIcon from '@mui/icons-material/Settings';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import FastForwardIcon from '@mui/icons-material/FastForward';
import MenuIcon from '@mui/icons-material/Menu';

import CreateIcon from '@mui/icons-material/Create';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';

import BorderColorIcon from '@mui/icons-material/BorderColor';
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
import PrintIcon from '@mui/icons-material/Print';
import TuneIcon from '@mui/icons-material/Tune';
import PauseIcon from '@mui/icons-material/Pause';
import { ReactComponent as MetronomeIcon } from "../29689/metronome.svg";

import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import DeleteIcon from '@mui/icons-material/Delete';

import { ThemeProvider, createTheme } from '@mui/material/styles';

import PlaybackSettingsPage from "./PlaybackSettingsPage.js"
import PrintingPage from "./PrintingPage.js"
import SettingsPage from "./SettingsPage.js"
import ScoreManagementPage from "./ScoreManagementPage.js"
import Keyboard from "./Keyboard/Keyboard.js"

import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';

import AnnotationCanvas from "./AnnotationCanvas.js"

import GradientSlider from "./GradientSlider.js"

import { styled } from '@mui/material/styles';

import settingSystem from "../SettingSystem.js"

import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

import TextManager from '../TextManager';

const colors = ["black", "red", "darkOrange", "gold", "seaGreen", "darkTurquoise", "royalBlue", "purple"]

const NavigationBarResponsiveWidth = "800px";

const StyledButton = styled(Button)(({ theme }) => ({
	// border: "1px solid black",
	border: "0",
	boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",

	// borderWidth: "2px",
	color: "black",

	":active": {
		border: "0",
		boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
		// border: "1px solid black",
	},

	":focus": {
		border: "0",
		boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
		// border: "1px solid black",
	},

	":hover": {
		border: "0",
		boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
		// border: "1px solid black",
	},
}));

export default class AnnotationToolbar extends React.Component {

	state = {
		resetCanvasConfirmDialogOpened: false,
		isNarrowScreen: window.matchMedia(`(max-width: ${NavigationBarResponsiveWidth})`).matches,

		menuOpened: false,
		menuItems: null,
		menuAnchor: null,
	}

	defaultBrushSize = 2;

	componentDidMount() {
		window.addEventListener('resize', () => {
			
			this.setState({
				menuOpened: false,
				isNarrowScreen: window.matchMedia(`(max-width: ${NavigationBarResponsiveWidth})`).matches,
			});
		});
	}

	render() {


		const generateColorButtons = (useRing = true, onColorButtonClicked = null) => {
			let buttons = []

			for (let i = 0; i < colors.length; i++) {
				buttons.push((
					<IconButton key={i} onClick={() => {
						settingSystem.setSetting("annotationBrushColor", colors[i], this)

						if (onColorButtonClicked) {
							onColorButtonClicked();
						}
					}}>
						<Box sx={{
							height: "18px",
							width: "18px",
							backgroundColor: colors[i],
							borderRadius: "50%",
							display: "inline-block",
						}}>
						</Box>

						{useRing ? <CircleOutlinedIcon sx={{
							position: "absolute",
							height: "38px",
							width: "38px",
							fill: "url(#gradientId)",
							display: settingSystem.getSetting("annotationBrushColor") == colors[i] ? "inherit" : "none",

						}} /> : null}
					</IconButton>
				))
			}

			return buttons;
		}

		const closeConfirmDialog = () => {
			this.setState({ resetCanvasConfirmDialogOpened: false });
		};

		const toolbar = <Stack direction="row" sx={{
			// backgroundColor: "rgba(255,255,255,1.0)", 
			/*backdropFilter: "blur(5px)", */
			// boxShadow: "0 0 15px rgba(0,0,0,1.0)",
			// zIndex: 1,
			color: "#111111",
			alignItems: "center",
			// justifyContent: "center",

			height: "45px",

			width: "fit-content",

			// overflowX: "hidden",
			// overflowY: "hidden",

		}}>
			<IconButton size="small" onClick={() => {
				this.setState({ resetCanvasConfirmDialogOpened: true });
			}}>
				<DeleteIcon sx={{
					fill: "red"
				}} />
			</IconButton>

			<IconButton size="small" onClick={() => {
				AnnotationCanvas.singleton.undo();
			}}>
				<UndoIcon sx={{
					width: "80%",
					fill: "black"
				}} />
			</IconButton>

			<IconButton size="small" onClick={() => {
				AnnotationCanvas.singleton.redo();
			}}>
				<RedoIcon sx={{
					width: "80%",
					fill: "black"
				}} />
			</IconButton>

			<Box sx={{
				background: "#111111",
				width: "2px",
				minWidth: "2px",
				height: "70%",
				margin: "0px 20px 0px 20px"
			}} />

			{/* <Typography sx={{ margin: "0px 6px" }}>Type</Typography> */}
			<IconButton size="small" onClick={() => {
				settingSystem.setSetting("annotationBrushType", 0, this);
			}}>
				<CreateIcon sx={{
					fill: settingSystem.getSetting("annotationBrushType") == 0 ? "url(#gradientId)" : "inherit"
				}} />
			</IconButton>
			<IconButton size="small" onClick={() => {
				settingSystem.setSetting("annotationBrushType", 1, this);
			}}>
				<DriveFileRenameOutlineIcon sx={{
					fill: settingSystem.getSetting("annotationBrushType") == 1 ? "url(#gradientId)" : "inherit"
				}} />
			</IconButton>
			<IconButton size="small" onClick={() => {
				settingSystem.setSetting("annotationBrushType", 2, this);
			}}>
				<AutoFixHighIcon sx={{
					fill: settingSystem.getSetting("annotationBrushType") == 2 ? "url(#gradientId)" : "inherit"
				}} />
			</IconButton>

			


			<Box sx={{
				background: "#111111",
				width: "2px",
				minWidth: "2px",
				height: "70%",
				margin: "0px 20px 0px 20px"
			}} />

			<Typography sx={{ margin: "0px 6px" }}>{TextManager.getText("size")}</Typography>

			<GradientSlider
				min={1} max={10} step={1}
				defaultValue={settingSystem.getSetting("annotationBrushSize")}
				onChangeCommitted={(e, v) => {
					settingSystem.setSetting("annotationBrushSize", v, this);
				}}
				sx={{
					width: "100px",
					minWidth: "100px",
					margin: "0 10px",
				}}
			/>

			<Box sx={{
				background: "#111111",
				width: "2px",
				minWidth: "2px",
				height: "70%",
				margin: "0px 20px 0px 20px"
			}} />

			{/* <Typography sx={{ margin: "0px 6px" }}>Colour</Typography> */}
			{generateColorButtons()}


			{/*
			<Box sx={{ 
				background: "#111111", 
				width:"2px", 
				minWidth:"2px",
				height:"70%", 
				margin:"0px 20px 0px 20px"
			}}/>
			
			<Button sx={{whiteSpace: "nowrap"}}>Clear All</Button>
			*/}
		</Stack>;

		////////////////////////////////////////////////////////////////
		// Mobile
		////////////////////////////////////////////////////////////////
		const closeMenu = () => {
			this.setState({
				menuOpened: false
			});
		}

		const brushTypeMenuItems = [
			<MenuItem variant="outlined" sx={{ width: "60px", height: "35px" }}
				onClick={(event) => {
					settingSystem.setSetting("annotationBrushType", 0, this);
					closeMenu();
				}}
			>
				<CreateIcon sx={{
					position: "absolute",
					height: "30px",
					// fill: settingSystem.getSetting("annotationBrushType") == 0 ? "url(#gradientId)" : "inherit"
				}} />
			</MenuItem >,
			<MenuItem variant="outlined" sx={{ width: "60px", height: "35px" }}
				onClick={(event) => {
					settingSystem.setSetting("annotationBrushType", 1, this);
					closeMenu();
				}}
			>
				<DriveFileRenameOutlineIcon sx={{
					position: "absolute",
					height: "30px",
					// fill: settingSystem.getSetting("annotationBrushType") == 0 ? "url(#gradientId)" : "inherit"
				}} />
			</MenuItem >,
			<MenuItem variant="outlined" sx={{ width: "60px", height: "35px" }}
				onClick={(event) => {
					settingSystem.setSetting("annotationBrushType", 2, this);
					closeMenu();
				}}
			>
				<AutoFixHighIcon sx={{
					position: "absolute",
					height: "30px",
					// fill: settingSystem.getSetting("annotationBrushType") == 0 ? "url(#gradientId)" : "inherit"
				}} />
			</MenuItem >
		]

		const brushSizeMenuItems = <GradientSlider
			orientation="vertical"
			min={1} max={10} step={1}
			defaultValue={settingSystem.getSetting("annotationBrushSize")}
			onChangeCommitted={(e, v) => {
				settingSystem.setSetting("annotationBrushSize", v, this);
			}}
			sx={{
				height: "100px",
				maxHeight: "100px",
				margin: "10px 0",
				'& input[type="range"]': {
					WebkitAppearance: 'slider-vertical',
				},
			}}
		/>

		let brushColorMenuItems = []
		for (const button of generateColorButtons(false, closeMenu)) {
			brushColorMenuItems.push(
				<Grid item xs={6} display="flex" justifyContent="center" alignItems="center">
					{button}
				</Grid>
			)
		}
		brushColorMenuItems = <Grid container columns={12} sx={{
			width: "80px",
			padding: "0px 10px",
		}}>
			{brushColorMenuItems}
		</Grid>

		const brushTypeIcons = [
			CreateIcon,
			DriveFileRenameOutlineIcon,
			AutoFixHighIcon
		]
		const ActiveBrushTypeIcon = brushTypeIcons[settingSystem.getSetting("annotationBrushType")];

		const toolbarMobile = <Stack direction="row" sx={{
			// boxsizing: "border-box",
			color: "#111111",
			alignItems: "center",
			height: "45px",
			width: "100%",
			maxWidth: "400px",
			justifyContent: "space-between",
			alignItems: "center",
			// padding: "10px 0px",
		}}>
			<Button sx={{ width: "30px", height: "35px" }} onClick={() => {
				this.setState({ resetCanvasConfirmDialogOpened: true });
			}}>
				<DeleteIcon sx={{
					position: "absolute",
					height: "30px",
					fill: "red"
				}} />
			</Button>

			<Stack direction="row" spacing={0}>
				<Button sx={{ width: "40px", height: "35px" }} onClick={() => {
					AnnotationCanvas.singleton.undo();
				}}>
					<UndoIcon sx={{
						width: "100%",
						fill: "black"
					}} />
				</Button>

				<Button sx={{ width: "40px", height: "35px" }} onClick={() => {
					AnnotationCanvas.singleton.redo();
				}}>
					<RedoIcon sx={{
						width: "100%",
						fill: "black"
					}} />
				</Button>
			</Stack>

			{/* <Stack direction="row" spacing={1}> */}
			<StyledButton sx={{ width: "60px", height: "35px" }}
				onClick={(event) => {
					this.setState({
						menuOpened: true,
						menuAnchor: event.currentTarget,
						menuItems: brushTypeMenuItems
					})
				}}
			>
				<ActiveBrushTypeIcon sx={{
					position: "absolute",
					height: "30px",
					fill: "url(#gradientId)"
				}} />
			</StyledButton>
			<StyledButton sx={{ width: "60px", height: "35px" }}
				onClick={(event) => {
					this.setState({
						menuOpened: true,
						menuAnchor: event.currentTarget,
						menuItems: brushSizeMenuItems
					})
				}}
			>
				<Stack spacing={-0.6} direction="column" sx={{
					position: "absolute",
				}}>
					<Typography sx={{ fontSize: "14px" }}>{TextManager.getText("size")}</Typography>
					<Typography sx={{ fontSize: "12px" }}>{settingSystem.getSetting("annotationBrushSize")}</Typography>
				</Stack>
			</StyledButton>
			<StyledButton sx={{ width: "60px", height: "35px" }}
				onClick={(event) => {
					this.setState({
						menuOpened: true,
						menuAnchor: event.currentTarget,
						menuItems: brushColorMenuItems
					})
				}}
			>
				<Stack spacing={0} direction="column" sx={{
					position: "absolute",
					alignItems: "center",
				}}>
					<Typography sx={{ fontSize: "14px" }}>{TextManager.getText("color")}</Typography>
					<Box sx={{
						width: "100%",
						height: "2px",
						marginBottom: "3px",
						bgcolor: settingSystem.getSetting("annotationBrushColor"),
						borderRadius: "9999px"
					}} />
				</Stack>
			</StyledButton>
			{/* </Stack> */}
		</Stack>


		////////////////////////////////////////////////////

		return (
			<Box sx={{
				width: "100%",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}>
				{this.state.isNarrowScreen ? toolbarMobile : toolbar}

				<Menu
					disableAutoFocusItem={true}
					anchorEl={this.state.menuAnchor}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'center',
					}}
					transformOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					open={this.state.menuOpened}
					onClose={(event) => closeMenu()}
				>
					{this.state.menuItems}
				</Menu>

				<Dialog
					open={this.state.resetCanvasConfirmDialogOpened}
					onClose={closeConfirmDialog}
				>
					<DialogTitle>
						{TextManager.getText("delete_all_notations")}
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{TextManager.getText("delete_all_notations_cannot_revert")}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button variant="contained" onClick={() => {
							AnnotationCanvas.singleton.resetCanvas();
							closeConfirmDialog();
						}}>
							{TextManager.getText("confirm")}
						</Button>
						<Button variant="outlined" onClick={closeConfirmDialog} autoFocus>
							{TextManager.getText("cancel")}
						</Button>
					</DialogActions>
				</Dialog>
			</Box>
		);
	}
};